import React, { useEffect, useRef, useState } from "react";
import { LucideScanQrCode, Play } from "lucide-react";
import Lottie from "lottie-react";
import parkingLottie from "../../assets/lottie/parking-lottie.json";
import { Modal, Button, Spinner } from "react-bootstrap";
import { apiCall } from "../../Apis/apiCall";
import { workflowApi } from "../../Apis/Api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePermissions } from "../../context/PermissionContext";
import AttendanceOverlay from "./AttendanceOverlay";
import QRScanner from "../QRScanner";
import { pointInPolygon } from "../../utils/PointInPolygon";
import { useGeolocated } from "react-geolocated";
import SubscriptionExpiredModal from "../SubscriptionExpiredModal";
import ClientPlanStatusModal from "../ClientPlanStatusModal";

const ParkingBanner = () => {
  const lottieRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [state, setState] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [attendanceCheck, setAttendanceCheck] = useState(false);
  const [showAttendanceOverlay, setShowAttendanceOverlay] = useState(false);
  const [currentLocationWorkflows, setCurrentLocationWorkflows] = useState([]);
  const [staffAssignments, setStaffAssignments] = useState([]);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [clientPlanStatus, setClientPlanStatus] = useState(false);
  const [isAnalyzingAssignments, setIsAnalyzingAssignments] = useState(false); // ← NAYA STATE ADDED
  const [clickedButtonType, setClickedButtonType] = useState(null); // 'start' ya 'scan'

  const userData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const { hasPermission, isAttendanceMarked, refreshAuthStatus } =
    usePermissions();

  const { assignedLocations } = usePermissions();
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 10000,
    });

  // Get current staff ID
  const currentStaffId = userData?.staff_id;

  // Determine current location based on geolocation
  const getCurrentLocation = () => {
    if (!isGeolocationAvailable) {
      return null;
    }
    if (!isGeolocationEnabled) {
      return null;
    }
    if (!coords?.latitude || !coords?.longitude) {
      return null;
    }

    const userPoint = { lat: coords.latitude, lng: coords.longitude };
    return assignedLocations.find((location) =>
      pointInPolygon(userPoint, location.polygons)
    );
  };

  const currentLocation = getCurrentLocation();

  // Analyze staff assignments and filter workflows for current location
  // const analyzeLocationWorkflowAssignments = async () => {
  //   try {
  //     const response = await apiCall("get", "/get-user-assignments");
  //     const data = response.data.data;

  //     // 🏢 FILTER WORKFLOWS FOR CURRENT LOCATION ONLY
  //     const currentLocationData = currentLocation
  //       ? data.find((loc) => loc.location_id === currentLocation.location_id)
  //       : null;

  //     if (currentLocationData) {
  //       const analyzedWorkflows = currentLocationData.workflows.map((wf) => {
  //         // 👥 CHECK IF CURRENT STAFF IS ASSIGNED TO FIRST STEP
  //         const firstStep = wf.steps[0];
  //         const assignedStaff = firstStep?.assigned_staff || [];

  //         // Check if current staff is in assigned staff
  //         const isCurrentStaffAssigned = assignedStaff.some(
  //           (staff) => staff.staff_id === currentStaffId
  //         );

  //         return {
  //           workflow_id: wf.workflow_id,
  //           workflow_name: wf.workflow_name,
  //           location_id: currentLocationData.location_id,
  //           location_name: currentLocationData.location_name,
  //           first_step_label: firstStep?.step_label || "No Step Found",
  //           is_current_staff_assigned: isCurrentStaffAssigned,
  //           assigned_staff: assignedStaff,
  //         };
  //       });

  //       setStaffAssignments(analyzedWorkflows);

  //       console.log("=== 📊 CURRENT LOCATION WORKFLOW ASSIGNMENTS ===");
  //       console.log(`📍 Current Location: ${currentLocation.location_name}`);
  //       console.log(`👤 Current Staff ID: ${currentStaffId}`);

  //       analyzedWorkflows.forEach((wf) => {
  //         console.log(
  //           `🔄 ${wf.workflow_name} - Assigned: ${wf.is_current_staff_assigned}`
  //         );
  //       });
  //     } else {
  //       setStaffAssignments([]);
  //       console.log("❌ No workflows found for current location");
  //     }

  //     return currentLocationData;
  //   } catch (error) {
  //     console.error("Error analyzing assignments:", error);
  //     setStaffAssignments([]);
  //     return null;
  //   }
  // };
  const analyzeLocationWorkflowAssignments = async () => {
    if (!currentLocation) {
      setStaffAssignments([]);
      setIsAnalyzingAssignments(false);
      return;
    }

    setIsAnalyzingAssignments(true); // ← Loading shuru

    try {
      const response = await apiCall("get", "/get-user-assignments");
      const data = response.data.data;

      const currentLocationData = data.find(
        (loc) => loc.location_id === currentLocation.location_id
      );

      if (currentLocationData && currentLocationData.workflows?.length > 0) {
        const analyzedWorkflows = currentLocationData.workflows.map((wf) => {
          let firstStep;
          let assignedStaff;
          let isCurrentStaffAssigned = false;
          if (wf.steps[0]?.step_order === 1) {
            firstStep = wf.steps[0];
            assignedStaff = firstStep?.assigned_staff || [];
            isCurrentStaffAssigned = assignedStaff.some(
              (staff) => staff.staff_id === currentStaffId
            );
          }else{
            isCurrentStaffAssigned = false
          }

          return {
            workflow_id: wf.workflow_id,
            workflow_name: wf.workflow_name,
            location_id: currentLocationData.location_id,
            location_name: currentLocationData.location_name,
            is_current_staff_assigned: isCurrentStaffAssigned,
            assigned_staff: assignedStaff,
          };
        });

        setStaffAssignments(analyzedWorkflows);
      } else {
        setStaffAssignments([]);
      }
    } catch (error) {
      console.error("Error fetching assignments:", error);
      // Purana data rakho, button gayab nahi hoga
    } finally {
      setIsAnalyzingAssignments(false); // ← Loading khatam
    }
  };
  // Check which buttons to show based on staff assignments
  // const getButtonVisibility = () => {
  //   if (!staffAssignments.length) return { showStart: false, showScan: false };

  //   const hasStartWorkflow = staffAssignments.some(
  //     (wf) => wf.is_current_staff_assigned
  //   );
  //   const hasScanWorkflow = staffAssignments.some(
  //     (wf) => !wf.is_current_staff_assigned
  //   );

  //   return {
  //     showStart: hasStartWorkflow,
  //     showScan: hasScanWorkflow,
  //   };
  // };
  const getButtonVisibility = () => {
    // Agar location hai aur pehli baar load ho raha hai → button dikhao + loading dikhao
    if (
      currentLocation &&
      staffAssignments.length === 0 &&
      isAnalyzingAssignments
    ) {
      return { showStart: true, showScan: true, isLoading: true };
    }

    if (!staffAssignments.length) {
      return { showStart: false, showScan: false, isLoading: false };
    }

    const hasStartWorkflow = staffAssignments.some(
      (wf) => wf.is_current_staff_assigned
    );
    const hasScanWorkflow = staffAssignments.some(
      (wf) => !wf.is_current_staff_assigned
    );

    return {
      showStart: hasStartWorkflow,
      showScan: hasScanWorkflow,
      isLoading: false,
    };
  };

  const {
    showStart,
    showScan,
    isLoading: buttonLoading,
  } = getButtonVisibility();
  // const { showStart, showScan } = getButtonVisibility();

  const handleLogout = async () => {
    localStorage.clear();
    await refreshAuthStatus();
    toast.success("Logout Successful");
    navigate("/sign-in", { replace: true });
  };

  const fetchWorkflows = async () => {
    setLoading(true);
    try {
      const response = await apiCall(
        "get",
        "/get-assigned-workflows-v2?page=1&per_page=5&sort_by=workflow_id&sort_order=asc"
      );
      if (response.data.success) {
        const workflowsData = response.data.data;

        // 🎯 FILTER WORKFLOWS FOR CURRENT LOCATION ONLY
        const filteredWorkflows = currentLocation
          ? workflowsData.filter(
              (workflow) => workflow.location_id === currentLocation.location_id
            )
          : workflowsData;

        if (filteredWorkflows.length === 0) {
          toast.info(
            `No workflows available for ${
              currentLocation?.location_name || "your current location"
            }`
          );
          return;
        }

        // Agar sirf 1 workflow hai tou directly start karo, modal mat dikhaao
        if (filteredWorkflows.length === 1) {
          handleWorkflowClick(filteredWorkflows[0]);
        } else {
          // Agar multiple workflows hain tou modal dikhao
          setWorkflows(filteredWorkflows);
          setShowModal(true);
        }
      } else {
        setError("Failed to fetch workflows");
      }
    } catch (err) {
      setError("Error fetching data");
      toast.error("Error fetching workflows: " + err.message);
    } finally {
      setLoading(false);
      setTimeout(() => {
        setState(false);
      }, 450);
    }
  };

  const handlePlayAnimation = async () => {
    try {
      if (isAttendanceMarked) {
        setAttendanceCheck(false);
        setState(true);
        setClickedButtonType("start");

        // Animation aur API call dono saath mein chalaao
        if (lottieRef.current) {
          lottieRef.current.stop();
          lottieRef.current.play();
        }

        // Foran API call karo, wait mat karo
        // fetchWorkflows().finally(() => {
        //   setState(false);
        // });
        // debounce
        await fetchWorkflows();
      } else {
        setAttendanceCheck(true);
        setShowAttendanceOverlay(true);
        setClickedButtonType("start");
      }
    } catch (error) {
      setAttendanceCheck(true);
      setShowAttendanceOverlay(true);
    }
  };

  const handleAttendanceSuccess = () => {
    setShowAttendanceOverlay(false);
    setAttendanceCheck(false);
    refreshAuthStatus();

    // Check karo ke konsa button click hua tha
    if (clickedButtonType === "start") {
      setTimeout(() => {
        setState(true);
        setTimeout(() => {
          fetchWorkflows();
          setState(false);
        }, 2000);
        if (lottieRef.current) {
          lottieRef.current.stop();
          lottieRef.current.play();
        }
      }, 800);
    } else if (clickedButtonType === "scan") {
      // Scan Ticket ke liye
      setTimeout(() => {
        setShowScanner(true);
      }, 800);
    }

    // Reset karo
    setClickedButtonType(null);
  };

  const handleCloseOverlay = () => {
    setShowAttendanceOverlay(false);
    setAttendanceCheck(false);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleWorkflowClick = async (workflow) => {
    setLoading(true);
    try {
      const workflowResponse = await workflowApi.startWorkflow(
        workflow.workflow_id,
        { location_id: workflow.location_id }
      );

      const instanceId =
        workflowResponse?.instance_id ||
        workflowResponse?.data?.instance_id ||
        workflowResponse?.workflow_instance_id ||
        workflowResponse?.data?.workflow_instance_id ||
        workflowResponse?.id ||
        workflowResponse?.data?.id;

      if (!instanceId) {
        throw new Error("No instance ID found in workflow response");
      }

      toast.success("Workflow started successfully!");

      navigate("/workflows-running", {
        state: {
          instanceId: instanceId,
          workflowId: workflow.workflow_id,
          workflowName: workflow.name,
          locationId: workflow.location_id,
          locationName: workflow.location_name,
        },
      });

      setShowModal(false);
    } catch (err) {
      toast.error(err.message || "Failed to start workflow");
    } finally {
      setLoading(false);
    }
  };

  const handleWorkflowTicket = async (ticketNumber) => {
    setLoading(true);
    try {
      const workflowResponse = await workflowApi.scanWorkflow(ticketNumber);

      const workflowId = workflowResponse?.data?.workflow_id;
      const workflowName = workflowResponse?.data?.workflow_name;
      const instanceId = workflowResponse?.data?.instance_id;
      const locationId = workflowResponse?.data?.location_id;
      const locationName = workflowResponse?.data?.location_name;

      if (!instanceId) {
        throw new Error("No instance ID found in workflow response");
      }

      toast.success(`Workflow started successfully!`);

      navigate("/workflows-running", {
        state: {
          instanceId: instanceId,
          workflowId: workflowId,
          workflowName: workflowName,
          locationId: locationId,
          locationName: locationName || "NO LOC FOUND",
        },
      });

      setShowModal(false);
    } catch (err) {
      toast.error(err.message || "Failed to start workflow");
      setShowModal(false);
      window.location.reload();
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  // Load staff assignments on component mount and when location changes
  useEffect(() => {
    analyzeLocationWorkflowAssignments();
  }, [currentLocation]);

  useEffect(() => {
    if (attendanceCheck && isAttendanceMarked) {
      setShowAttendanceOverlay(false);
      setAttendanceCheck(false);

      // setTimeout(() => {
      //   setState(true);
      //   setTimeout(() => {
      //     fetchWorkflows();
      //     // setShowModal(true);
      //     setState(false);
      //   }, 2000);
      //   if (lottieRef.current) {
      //     lottieRef.current.stop();
      //     lottieRef.current.play();
      //   }
      // }, 500);

      // Check karo ke konsa button click hua tha
      if (clickedButtonType === "start") {
        setTimeout(() => {
          setState(true);
          setTimeout(() => {
            fetchWorkflows();
            setState(false);
          }, 2000);
          if (lottieRef.current) {
            lottieRef.current.stop();
            lottieRef.current.play();
          }
        }, 800);
      } else if (clickedButtonType === "scan") {
        // Scan Ticket ke liye
        setTimeout(() => {
          setShowScanner(true);
        }, 800);
      }

      // Reset karo
      setClickedButtonType(null);
    }
  }, [isAttendanceMarked, attendanceCheck]);

  const getClientPlanStatus = async () => {
    try {
      const response = await apiCall("get", "/get-client-plan-status");
      const data = response.data.data;
      if (data) {
        setClientPlanStatus(data);
        if (
          data?.max_vehicles_allowed === data?.parked_till_now &&
          data?.is_plan_fully_used === true
        ) {
          setShowExpiredModal(true);
        } else {
          setShowExpiredModal(false);
        }
      } else {
        setClientPlanStatus(null);
        setShowExpiredModal(false);
      }
    } catch (error) {
      setClientPlanStatus(null);
      setShowExpiredModal(false);
    }
  };
  useEffect(() => {
    getClientPlanStatus();
  }, []);

  return (
    <>
      <style>
        {`
          /* Bootstrap Modal Overrides */
          .modal-content {
            background: var(--white);
            border-radius: var(--rounded-12);
            box-shadow: var(--shadow-2);
            font-family: var(--default-font);
            border: none;
          }

          [data-theme='dark'] .modal-content {
            background: var(--dark-1);
          }

          .modal-header {
            padding: var(--size-16) var(--size-24);
            border-bottom: 1px solid var(--neutral-200);
          }

          [data-theme='dark'] .modal-header {
            border-bottom: 1px solid var(--neutral-200);
          }

          .modal-title {
            font-size: var(--font-xl);
            font-weight: 600;
            color: var(--text-primary-light);
          }

          [data-theme='dark'] .modal-title {
            color: var(--text-primary-light);
          }

          .modal-body {
            padding: var(--size-24);
            color: var(--text-primary-light);
          }

          [data-theme='dark'] .modal-body {
            color: var(--text-primary-light);
          }

          .modal-footer {
            padding: var(--size-16) var(--size-24);
            border-top: 1px solid var(--neutral-200);
          }

          [data-theme='dark'] .modal-footer {
            border-top: 1px solid var(--neutral-200);
          }

          .modal-header .btn-close {
            background: none;
            color: var(--text-primary-light);
            font-size: var(--font-lg);
            opacity: 1;
            transition: color 0.3s ease;
          }

          .modal-header .btn-close:hover {
            color: var(--primary-600);
          }

          [data-theme='dark'] .modal-header .btn-close {
            color: var(--text-primary-light);
          }

          [data-theme='dark'] .modal-header .btn-close:hover {
            color: var(--primary-700);
          }

          /* Table Styles */
          .workflow-table-container {
            overflow-x: auto;
            width: 100%;
            margin-bottom: var(--size-16);
          }

          .workflow-table {
            background-color: var(--white);
            border-radius: var(--rounded-8);
            overflow: hidden;
            box-shadow: var(--shadow-2);
            width: 100%;
            border-collapse: collapse;
          }

          [data-theme='dark'] .workflow-table {
            background-color: var(--dark-1);
          }

          .workflow-table thead {
            background-color: var(--primary-600);
            color: var(--neutral-50);
          }

          .workflow-table th {
            font-size: var(--font-md);
            font-weight: 600;
            padding: var(--size-16);
            text-align: left;
            border-bottom: 2px solid var(--neutral-200);
            border-right: 1px solid var(--neutral-200);
          }

          .workflow-table th:last-child {
            border-right: none;
          }

          [data-theme='dark'] .workflow-table th {
            border-bottom: 2px solid var(--neutral-200);
            border-right: 1px solid var(--neutral-200);
          }

          // .workflow-table tbody tr:nth-child(odd) {
          //   background-color: var(--neutral-50);
          // }

          // .workflow-table tbody tr:nth-child(even) {
          //   background-color: var(--neutral-100);
          // }

          // [data-theme='dark'] .workflow-table tbody tr:nth-child(odd) {
          //   background-color: var(--dark-1);
          // }

          // [data-theme='dark'] .workflow-table tbody tr:nth-child(even) {
          //   background-color: var(--neutral-100);
          // }

          .workflow-table tbody tr {
            transition: all 0.3s ease;
            cursor: pointer;
          }

          .workflow-table tbody tr:hover {
            background-color: var(--neutral-200);
            // transform: translateY(-10px);
            box-shadow: var(--shadow-1);
          }

          [data-theme='dark'] .workflow-table tbody tr:hover {
            background-color: var(--neutral-200);
          }

          .workflow-table td {
            font-size: var(--font-sm);
            padding: var(--size-12) var(--size-16);
            color: var(--text-primary-light);
            vertical-align: middle;
            border-bottom: 1px solid var(--neutral-200);
            border-right: 1px solid var(--neutral-200);
          }

          .workflow-table td:last-child {
            border-right: none;
          }

          [data-theme='dark'] .workflow-table td {
            color: var(--text-primary-light);
            border-bottom: 1px solid var(--neutral-200);
            border-right: 1px solid var(--neutral-200);
          }

          .workflow-table td:first-child {
            width: 10%;
            text-align: center;
          }

          .workflow-table .workflow-name {
            color: var(--primary-600);
            font-weight: 500;
            transition: color 0.3s ease;
          }

          .workflow-table .workflow-name:hover {
            color: var(--primary-700);
          }

          /* Responsive Table Adjustments */
          @media (max-width: 768px) {
            .workflow-table th,
            .workflow-table td {
              font-size: var(--font-sm);
              padding: var(--size-8) var(--size-12);
            }

            .workflow-table td:first-child {
              width: 15%;
            }
          }

          @media (max-width: 576px) {
            .workflow-table th,
            .workflow-table td {
              font-size: var(--font-xs);
              padding: var(--size-8);
            }

            .workflow-table td:first-child {
              width: 20%;
            }
          }

          /* Parking Banner Styles */
          .parking-card-bg {
            position: relative;
            width: 100%;
            aspect-ratio: 17 / 6;
            border-radius: var(--rounded-24);
            overflow: hidden;
            background-color: var(--white);
            isolation: isolate;
          }

          [data-theme='dark'] .parking-card-bg {
            background-color: var(--white);
          }

          .parking-lottie-bg {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
          }

          .parking-card-content {
            position: absolute;
            inset: 0;
            padding: var(--size-24);
            z-index: 5;
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            clip-path: inset(0);
          }
 .parking-start-button {
  position: static !important;
  z-index: auto;
  max-width: 200px;
  word-wrap: break-word;
  flex-shrink: 1;
  background-color: var(--primary-600);
  color: white;
  padding: var(--size-12) var(--size-24);
  border-radius: var(--rounded-8);
  font-size: var(--font-md);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: var(--size-8);
  transition: all 0.3s ease;
  border: none;
}

.parking-start-button:hover {
  background-color: var(--primary-300);
}


.parking-start-button:disabled {
  background-color: var(--neutral-500);
  cursor: not-allowed;
}

/* Hide text on small screens (sm) */
@media (max-width: 576px) {
  .parking-start-button .fw-semibold {
    display: none; /* Hides the text */
  }
  .parking-start-button {
    padding: var(--size-12); /* Adjust padding for icon-only button */
    max-width: 48px; /* Optional: reduce button width for icon-only */
    justify-content: center; /* Center the icon */
  }
}
         
.parking-scan-button {
  position: static !important;
  z-index: auto;
  max-width: 200px;
  word-wrap: break-word;
  flex-shrink: 1;
  // background-color: var(--primary-600);
  border:1px solid var(--primary-600);
  color: var(--primary-600);
  padding: var(--size-12) var(--size-24);
  border-radius: var(--rounded-8);
  font-size: var(--font-md);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: var(--size-8);
  transition: all 0.3s ease;
}

.parking-scan-button:hover {
  background-color: var(--primary-20);
}


.parking-scan-button:disabled {
  background-color: var(--neutral-500);
  cursor: not-allowed;
}

/* Hide text on small screens (sm) */
@media (max-width: 576px) {
  .parking-scan-button .fw-semibold {
    display: none; /* Hides the text */
  }
  .parking-scan-button {
    padding: var(--size-12); /* Adjust padding for icon-only button */
    max-width: 48px; /* Optional: reduce button width for icon-only */
    justify-content: center; /* Center the icon */
  }
}
          /* Other Existing Styles */
          .error-message {
            color: var(--danger-600);
            font-weight: 500;
            font-size: var(--font-md);
            text-align: center;
          }

          [data-theme='dark'] .error-message {
            color: var(--danger-600);
          }

          /* Attendance Overlay Styles */
          .geolocation-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }

          .geolocation-overlay-content {
            background: var(--white);
            border-radius: var(--rounded-12);
            padding: var(--size-24);
            max-width: 32rem;
            width: 100%;
            text-align: center;
            box-shadow: var(--shadow-2);
            position: relative;
          }

          [data-theme='dark'] .geolocation-overlay-content {
            background: var(--dark-1);
          }

          .geolocation-overlay-content .close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: var(--text-primary-light);
          }

          [data-theme='dark'] .geolocation-overlay-content .close-button {
            color: var(--text-primary-light);
          }

          .geolocation-overlay-content h3 {
            font-size: var(--font-xl);
            font-weight: 600;
            color: var(--text-primary-light);
            margin-bottom: var(--size-16);
          }

          [data-theme='dark'] .geolocation-overlay-content h3 {
            color: var(--text-primary-light);
          }

          .geolocation-overlay-content p {
            font-size: var(--font-md);
            color: var(--text-secondary-light);
          }

          [data-theme='dark'] .geolocation-overlay-content p {
            color: var(--text-secondary-light);
          }

          .geolocation-overlay-content .retry-button,
          .geolocation-overlay-content .logout-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: var(--size-8);
            padding: var(--size-12) var(--size-24);
            border: none;
            border-radius: var(--rounded-8);
            font-size: var(--font-md);
            font-weight: 500;
            cursor: pointer;
            transition: background 0.3s ease;
          }

          .geolocation-overlay-content .retry-button {
            background: var(--primary-600);
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .retry-button:hover {
            background: var(--primary-700);
          }

          [data-theme='dark'] .geolocation-overlay-content .retry-button {
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .logout-button {
            background: var(--danger-600);
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .logout-button:hover {
            background: var(--danger-700);
          }

          [data-theme='dark'] .geolocation-overlay-content .logout-button {
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .button-group {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            margin-top: 16px;
          }

          .attendance-success {
            color: var(--success-600);
            font-weight: 500;
            margin-top: 8px;
          }

          /* Responsive Modal Adjustments */
          @media (max-width: 768px) {
            .modal-content {
              padding: var(--size-16);
            }

            .modal-title {
              font-size: var(--font-lg);
            }

            .modal-body {
              padding: var(--size-16);
            }

            .modal-footer {
              padding: var(--size-12) var(--size-16);
            }
          }

          @media (max-width: 576px) {
            .modal-title {
              font-size: var(--font-md);
            }

            .modal-header .btn-close {
              font-size: var(--font-md);
            }

            .btn {
              padding: var(--size-8) var(--size-16);
              font-size: var(--font-sm);
            }
          }

         .loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--size-24);
  gap: var(--size-8);
}

.custom-spinner {
  width: 32px;
  height: 32px;
  border: 4px solid var(--neutral-200);
  border-top: 4px solid var(--primary-600);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

[data-theme='dark'] .custom-spinner {
  border: 4px solid var(--neutral-600);
  border-top: 4px solid var(--primary-400);
}

.loader-text {
  font-size: var(--font-md);
  color: var(--text-primary-light);
  font-weight: 500;
}

[data-theme='dark'] .loader-text {
  color: var(--text-primary-light);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

        `}
      </style>

      <div className="parking-card-bg">
        <div className="parking-lottie-bg">
          <Lottie
            lottieRef={lottieRef}
            animationData={parkingLottie}
            loop={false}
            autoplay={false}
          />
        </div>

        <div className="parking-card-content">
          {/* {hasPermission("view_workflow_running") && (
            <button
              className="parking-start-button"
              onClick={handlePlayAnimation}
              disabled={state || showAttendanceOverlay}
            >
              {state ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : (
                <Play size={16} fill="white" />
              )}
              <span className="fw-semibold ms-2">
                {state ? "Starting..." : "Start Parking"}
              </span>
            </button>
          )} */}
          {hasPermission("view_workflow_running") && (
            <div style={{ display: "flex", gap: "12px" }}>
              {/* Start Parking Button */}

              {/* {showStart && (
                <>
                  <button
                    className="parking-start-button"
                    onClick={handlePlayAnimation}
                    disabled={state || showAttendanceOverlay}
                  >
                    {state ? (
                      <Spinner animation="border" size="sm" className="me-2" />
                    ) : (
                      <Play size={24} fill="white" />
                    )}
                    <span className="fw-semibold ms-2">
                      {state ? "Starting..." : "Start Parking"}
                    </span>
                  </button>
                </>
              )} */}
              {showStart && (
                <button
                  className="parking-start-button"
                  onClick={handlePlayAnimation}
                  disabled={state || showAttendanceOverlay || buttonLoading} // ← buttonLoading se disable
                  style={{ opacity: buttonLoading ? 0.7 : 1 }}
                >
                  {buttonLoading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span className="fw-semibold ms-2">Please wait...</span>
                    </>
                  ) : state ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span className="fw-semibold ms-2">Starting...</span>
                    </>
                  ) : (
                    <>
                      <Play size={24} fill="white" />
                      <span className="fw-semibold ms-2">Start Parking</span>
                    </>
                  )}
                </button>
              )}
              <button
                className="parking-scan-button"
                // onClick={() => {
                //   if (!isAttendanceMarked) {
                //     toast.error("Please mark attendance first");
                //     return;
                //   }
                //   setShowScanner(true);
                // }}
                onClick={() => {
                  if (!isAttendanceMarked) {
                    // Attendance nahi hai - Popup dikhao (pehle toast tha)
                    setAttendanceCheck(true);
                    setClickedButtonType("scan");
                    setShowAttendanceOverlay(true);
                  } else {
                    // Attendance hai - Scanner dikhao
                    setShowScanner(true);
                  }
                }}
                disabled={buttonLoading} // ← yahan bhi disable
                style={{ opacity: buttonLoading ? 0.6 : 1 }}
              >
                <LucideScanQrCode size={24} />
                <span className="fw-semibold ms-2">
                  {buttonLoading ? "Loading..." : "Scan Ticket"}
                </span>
              </button>
              {/* Scan Ticket Button */}
              {/* <button
                className="parking-scan-button"
                // onClick={handleWorkflowTicket}
                onClick={() => {
                  if (isAttendanceMarked) {
                    setShowScanner(true);
                  }else{
                    toast.error("Please Attendance Mark")
                  }
                }}
              >
                <LucideScanQrCode size={24} fill="white" />
                <span className="fw-semibold ms-2">Scan Ticket</span>
              </button> */}
            </div>
          )}
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>
              Assigned Workflows -{" "}
              {currentLocation?.location_name || "All Locations"}
            </h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div className="loader-container">
              <div className="custom-spinner"></div>
              <p className="loader-text">Loading Workflows...</p>
            </div>
          )}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && workflows.length > 0 ? (
            <div className="workflow-table-container table-responsive">
              <table className="workflow-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>WorkFlow Name</th>
                    <th>Branch</th>
                    <th>Location</th>
                    <th>Assignment</th>
                  </tr>
                </thead>
                <tbody>
                  {workflows.map((workflow, index) => {
                    const staffAssignment = staffAssignments.find(
                      (assignment) =>
                        assignment.workflow_id === workflow.workflow_id
                    );
                    const isAssigned =
                      staffAssignment?.is_current_staff_assigned;

                    return (
                      <tr
                        key={workflow.id}
                        className="workflow-row"
                        onClick={() =>
                          isAssigned
                            ? handleWorkflowClick(workflow)
                            : setShowScanner(true)
                        }
                      >
                        <td>{index + 1}</td>
                        <td className="text-primary-600 workflow-name">
                          {workflow.name}
                        </td>
                        <td>{workflow.branch_name}</td>
                        <td>{workflow.location_name}</td>
                        <td>
                          <span
                            style={{
                              color: isAssigned
                                ? "var(--success-600)"
                                : "var(--neutral-500)",
                              fontWeight: "500",
                              fontSize: "var(--font-xs)",
                            }}
                          >
                            {isAssigned ? "✅ Assigned" : "🔍 Scan Only"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            !loading && (
              <p className="text-neutral-600">
                {currentLocation
                  ? `No workflows available for ${currentLocation.location_name}`
                  : "No workflows available"}
              </p>
            )
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <AttendanceOverlay
        show={showAttendanceOverlay}
        onClose={handleCloseOverlay}
        onLogout={handleLogout}
        onSuccess={handleAttendanceSuccess}
      />
      <QRScanner
        show={showScanner}
        onClose={() => setShowScanner(false)}
        onScan={(ticketNumber) => handleWorkflowTicket(ticketNumber)}
      />
      {showExpiredModal && (
        <ClientPlanStatusModal
          onClose={() => setShowExpiredModal(false)}
          clientPlanStatus={clientPlanStatus}
        />
      )}
    </>
  );
};

export default ParkingBanner;
